import { useContext, useMemo } from "react";
import { VersionedDataContext } from "../../contexts/versioned_data/context";
import { RunHistoryComponent } from "./component";

export const RunHistoryContainer = () => {
  const {
    loading: versionedDataLoading,
    mainRun,
    setMainRun,
    atomicPivotRuns,
    lastSuccessfulRun,
  } = useContext(VersionedDataContext);

  const successfulRuns = useMemo(
    () => atomicPivotRuns.filter((run) => run.status === "RUN_COMPLETED"),
    [atomicPivotRuns]
  );

  return (
    <RunHistoryComponent
      loading={versionedDataLoading}
      runs={successfulRuns}
      mainRun={mainRun || null}
      setMainRun={setMainRun}
      lastSuccessfulRun={lastSuccessfulRun || null}
    />
  );
};
